import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { LazyHorizontalOperationsNav } from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import {
	resources as opsReportsResources,
	opsReportsPermissionResource,
} from '@atlassian/eoc-ops-reports-common/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocGlobalReportsHomePageNav4Route } from '@jira/router-routes__eoc-reports-routes/src/eocGlobalReportsHomePageNav4Route.tsx';
import { opsMigrationHubLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyOpsReportsRedirect, OpsReportsRedirect } from './ui/spa/eoc/ops-reports/index.tsx';

export const eocGlobalReportsHomePageNav4RouteEntry: Route = createEntry(
	eocGlobalReportsHomePageNav4Route,

	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: OpsReportsRedirect,
		layout: opsMigrationHubLayout,

		resources: [
			...getNavigationResources(),
			...opsReportsResources(),
			opsReportsPermissionResource,
			getConsolidationStateResource(),
		],

		navigation: {
			menuId: MenuIdPeople,
		},

		forPaint: [
			LazyHorizontalOperationsNav,
			LazyAtlassianNavigation,
			LazyOpsReportsRedirect,
			LazyTeamDashboardSidebar,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
